import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="border-t border-white/5 py-10 px-6 md:px-12"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-2 text-sm">
          <span className="inline-flex h-6 w-6 items-center justify-center rounded bg-[#00E5FF] text-black font-display font-bold text-xs">
            T
          </span>

          <span className="font-display font-semibold">
            TapToTable
          </span>

          <span className="text-zinc-500">
            — Turn Online Interest Into More Restaurant Visits
          </span>
        </div>

        <nav
          className="flex items-center gap-5 text-sm"
          aria-label="Legal"
          data-testid="footer-legal-nav"
        >
          <Link
            to="/privacy"
            className="text-zinc-400 hover:text-white transition-colors"
            data-testid="footer-privacy-link"
          >
            Privacy Policy
          </Link>

          <span
            aria-hidden
            className="text-zinc-700"
          >
            ·
          </span>

          <Link
            to="/terms"
            className="text-zinc-400 hover:text-white transition-colors"
            data-testid="footer-terms-link"
          >
            Terms of Service
          </Link>
        </nav>

        <div className="text-zinc-500 text-xs">
          © {new Date().getFullYear()} TapToTable by Melted Port Studios LLC. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
